module.exports = __webpack_public_path__ + "static/media/down-arrow.c76c1fa1.svg";